var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChnFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v45H0V0Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2 16.65 11.25 4.5l4.05 12.15L4.5 9.225H18L7.2 16.65ZM24.766 4.733l-4.168.923 2.78-3.24-.273 4.36-2.313-3.86 3.974 1.817ZM28.972 10.064l-4.2-.765 3.82-1.908-1.943 3.913-.635-4.455 2.958 3.215ZM28.36 17.543l-3.523-2.412 4.265-.184-3.37 2.78 1.238-4.326 1.39 4.142ZM23.061 22.429l-2.317-3.585 4.005 1.477-4.182 1.263 2.812-3.512-.318 4.357Z",
    fill: "#FF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChnFlag);
export default __webpack_public_path__ + "static/media/chn-flag.dbea8657c5d3f734caf3ee20b3ee60d6.svg";
export { ForwardRef as ReactComponent };